import React from 'react';
import useStyles from './VideoExtractor.styles';
import { Button, LinearProgress, TextField } from '@material-ui/core';
import { useVideoExtractor } from '../../hooks/useVideoExtractor';

export const VideoExtractor: React.FC = () => {
  const classes = useStyles();
  const { videoId, handleVideoExtraction, handleChange, loading } = useVideoExtractor();
  return (
    <div className={classes.Root}>
      {loading && <LinearProgress />}
      <TextField
        size="small"
        value={videoId}
        variant="outlined"
        onChange={handleChange}
        className={classes.Text}
        id="extract-existing-video"
        label="Extract Existing Video"
      />
      <Button color="primary" variant="text" onClick={handleVideoExtraction}>
        Extract
      </Button>
    </div>
  );
};
